import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DisabledAlertBase = ({
  message,
  type,
  button
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      margin: "600",
      children: /*#__PURE__*/_jsxs(Alert, {
        type: type,
        children: [message, /*#__PURE__*/_jsx(ButtonWrapper, {
          marginBlockStart: "100",
          children: button
        })]
      })
    })
  });
};
DisabledAlertBase.displayName = 'DisabledAlertBase';
export default DisabledAlertBase;